<div>
    <div class="modal-header customBlueHeader">
        <p class="modal-title">Reimbursement Tracking Status</p> 
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div> 

    <div class="modal-body customModalBody">
        <table class="table table-striped table-hover table-responsive customTable">
            <thead>
                <tr>
                    <th>Employee ID</th>
                    <th>MRN</th>
                    <th>Transaction ID</th>
                    <th>Claim ID</th>
                    <th>Reimbursement Status</th>
                     <th>Created On</th>
                </tr> 

            <tbody>
                <tr *ngFor="let data of  reimburseStatusList">
                    <td>{{reimburseDetailsRes[0].employeeId}}</td>
                    <td>{{reimburseDetailsRes[0].mrn}}</td>
                    <td>{{reimburseDetailsRes[0].transactionId}}</td>
                    <td>{{data.claimId}}</td>
                    <td>{{statuslist[data.statusCode]}}</td>
                   <td>{{data.createdDate | date:'dd/MM/yyyy hh:mm a':'UTC'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>